import routes from '../Router/routes.constants'

const initValue = {
  finished: false,
  displayMessages: [],
  consentModal: null,
  consentModalAccepted: false,
  deliveryMethods: [],
  variants: {},
  bankAccounts: [],
  allowed_region: {
    id: '',
    name: '',
    code: '',
    provinces: [],
  },
  orderAmount: {
    original_amount: null,
    fee_amount: null,
    fees: {},
    summary_total_amount: null,
    exchange_items_amount: null,
    currency: 'EUR',
    amount: null,
    remaining_amount: null,
    remaining_amount_in_store_currency: null,
    reveni_coverage_amount: null,
    bonus_amount: null,
    bonuses: {},
  },
  merchantInfo: {
    id: '',
    returnPortalId: '',
    storeId: '',
    siblingReturnPortals: [],
    name: '',
    slug: '',
    contact_email: '',
    disable_return_label_delay: false,
    domain: '',
    currency: '',
    merchant: {
      id: '',
      country: { code: '', name: '', phone_code: '', region_id: '' },
      stores: [],
    },
    country: {
      code: '',
      name: '',
      phone_code: '',
      region_id: '',
    },
    preferences: {
      transaction_types: [],
      delivery_methods: [],
      max_duration_for_return: '',
      reject_url: '',
      return_expiration_delta: '',
      shipping_included: false,
      success_url: '',
      returns_policy_url: null,
      allows_unified_flow: false,
      allows_instant_exchanges: false,
      disable_preselected_refund_methods: false,
      disable_preselected_delivery_methods: false,
      allows_multi_order_returns: false,
      portal_type: '',
      promote_exchanges: false,
      skip_identifier_validation: false,
      allows_order_recovery: false,
      help_center_url: '',
    },
    theme: {
      returns_background_url: '',
      returns_background_mobile_url: '',
      logo_url: '',
      custom_progress_bar: false,
      complete_image: false,
      partner_logo_url: '',
      partner_url: '',
    },
  },
  orderInfo: {
    is_instant_exchange_allowed: false,
    email: '',
    identifier: '',
    id: '',
    type: '',
    currency: '',
    returnId: '',
    orderNumber: '',
    original_shipping_address: {},
    shipping_address: {},
    transaction_type: '',
    reject_url: '',
    success_url: '',
    allowed_refund_methods: [],
    issue_refund_at_status: '',
    gift_recipient: null,
    is_gift_return: false,
    exchange_shipping_address: {},
    use_same_address_for_exchange: true,
    exchanged_for_order: {
      amount: '',
      currency: '',
      checkout_url: '',
      needs_payment: false,
    },
    customer_profile: {
      first_name: '',
      last_name: '',
      email: {
        id: '',
        email: '',
        primary: '',
        verified: '',
      },
    },
    carbon_offset: false,
    carbonOffset: false,
    customer_iban: null,
    numberOfReturnLabels: 1,
    selectedPickupDate: null,
    selectedTimeRange: null,
    customers_url: '',
    available_transaction_types: [],
    available_transaction_types_for_region: [],
    bankAccount: {},
    return_group: {
      return_is_main: true,
      order_names: [],
    },
    joinGroup: false,
    availableGroupAction: null,
    fee_messages: [],
  },
  orderRecovery: {
    token: '',
  },
  items: [],
  draftItems: [],
  //all the flows has this steps
  processSteps: [routes.productSelectionPage, routes.deliveryMethodsPage, routes.summaryPage],
  summaryInputs: {
    fees: {},
    bonuses: {},
    previewFees: {},
    previewBonuses: {},
    previewFeeMessages: [],
  },
  summaryCollapsed: false,
}

export default initValue
